export default "<p>listdevice works!</p>\n";